export const breadcrumb = {
  title: 'Calls',
  trunk: {
    index: 'SIP trunks'
  }
};
